module.exports = __webpack_public_path__ + "assets/img/ic-switch.6654a4c9.svg";